import React from 'react';
import LocalizationManager from '../../../utils/localization/localization';

const ModernServices = () => {
  const services = [
    {
      id: 'b2b',
      number: '01',
      title: LocalizationManager.t('solutionsB2BTitle'),
      description: LocalizationManager.t('solutionsB2BDescription'),
      featuresKeys: ['servicesFeatureB2BOne', 'servicesFeatureB2BTwo', 'servicesFeatureB2BThree'],
      gradient: 'from-blue-600 to-cyan-600'
    },
    {
      id: 'b2c',
      number: '02',
      title: LocalizationManager.t('solutionsB2CTitle'),
      description: LocalizationManager.t('solutionsB2CDescription'),
      featuresKeys: ['servicesFeatureB2COne', 'servicesFeatureB2CTwo', 'servicesFeatureB2CThree'],
      gradient: 'from-pink-600 to-rose-600'
    },
    {
      id: 'fullstack',
      number: '03',
      title: LocalizationManager.t('solutionsFullStackTitle'),
      description: LocalizationManager.t('solutionsFullStackDescription'),
      featuresKeys: ['servicesFeatureFullStackOne', 'servicesFeatureFullStackTwo', 'servicesFeatureFullStackThree'],
      gradient: 'from-purple-600 to-indigo-600'
    }
  ];

  return (
    <section id="services" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-dark-950">
      {/* Section background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16 animate-slideUp">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            {LocalizationManager.t('solutionsTitle')}
          </h2>
          <p className="max-w-2xl mx-auto text-xl text-dark-300">
            {LocalizationManager.t('servicesSubtitle')}
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group relative"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Glass card */}
              <div className="glass p-8 rounded-2xl h-full backdrop-blur-xl hover:backdrop-blur-2xl transition-all duration-500 overflow-hidden">
                {/* Gradient overlay on hover */}
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500 pointer-events-none`}
                ></div>

                {/* Content */}
                <div className="relative z-10">
                  {/* Number Badge */}
                  <div className="text-5xl font-bold text-purple-400 mb-6 opacity-50">
                    {service.number}
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-purple-400 group-hover:to-pink-400 group-hover:bg-clip-text transition-all duration-500">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-dark-300 text-base leading-relaxed mb-6">
                    {service.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 pt-6 border-t border-white border-opacity-10">
                    {service.featuresKeys.map((featureKey, i) => (
                      <div key={i} className="flex items-center gap-3 text-dark-200">
                        <svg
                          className="w-5 h-5 text-purple-400 flex-shrink-0"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span className="text-sm">{LocalizationManager.t(featureKey)}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA Link */}
                  <button className="mt-8 w-full py-3 px-4 rounded-lg font-semibold text-white bg-white bg-opacity-10 hover:bg-opacity-20 border border-white border-opacity-20 hover:border-opacity-40 transition-all duration-300">
                    {LocalizationManager.t('servicesLearnMore')} →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModernServices;
